import { PIXEL_RATIO } from "./pixelRatio";

export const createHiDPICanvas = function (w, h, ratio) {
  if (!ratio) {
    ratio = PIXEL_RATIO;
  }
  var can = document.getElementById("myCanvas");
  can.width = w * ratio;
  can.height = h * ratio;
  can.style.width = w + "px";
  can.style.height = h + "px";
  can.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
  return can;
};

// let ratio = window.devicePixelRatio;
// let cv = document.createElement("canvas");
// cv.width = w * ratio;
// cv.height = h * ratio;
// cv.style.width = w + "px";
// cv.style.height = h + "px";
// cv.getContext("2d").scale(ratio, ratio);
